import { type OptionsConnexion, optionsConnexionSchema } from '@carte/contrats/auth';
import { ErreurApi, obtenir } from '../api';

export const MESSAGE_COMPTE_BLOQUE = "Compte en attente d'activation ou bloqué. Contactez un administrateur.";

export function chargerOptions(): Promise<OptionsConnexion> {
  return obtenir('/api/auth/options', optionsConnexionSchema);
}

/** N'accepte qu'un chemin interne : jamais d'adresse externe ni de `//hote`. */
export function retourSur(brut: string | null | undefined): string {
  if (!brut?.startsWith('/') || brut.startsWith('//') || brut.startsWith('/\\')) return '/';
  if (brut.startsWith('/connexion')) return '/';
  return brut;
}

/** Message en français pour un paramètre `?error=` renvoyé par la connexion Microsoft. */
export function messagePourErreurUrl(code: string | null): string | null {
  if (!code) return null;
  const c = code.toLowerCase();
  if (c.includes('banned') || c.includes('attente') || c.includes('bloque')) return MESSAGE_COMPTE_BLOQUE;
  return 'La connexion Microsoft a échoué. Réessayez, ou contactez un administrateur si cela se répète.';
}

export function messageErreurConnexion(e: unknown): string {
  if (e instanceof ErreurApi) {
    if (e.statut === 401) return 'Courriel ou mot de passe incorrect.';
    if (e.statut === 403 && e.code === 'connexion_locale_desactivee') {
      return 'La connexion par mot de passe est désactivée. Utilisez le compte Microsoft.';
    }
    if (e.statut === 403) return MESSAGE_COMPTE_BLOQUE;
    if (e.statut === 429) return 'Trop de tentatives. Patientez une minute avant de réessayer.';
  }
  return "Le serveur n'a pas pu répondre. Réessayez dans un instant.";
}

async function poster(chemin: string, corps: unknown): Promise<Record<string, unknown>> {
  const reponse = await fetch(chemin, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(corps),
  });
  const json = (await reponse.json().catch(() => ({}))) as Record<string, unknown>;
  if (!reponse.ok) {
    const code =
      typeof json.erreur === 'string' ? json.erreur : typeof json.code === 'string' ? json.code : 'erreur';
    throw new ErreurApi(reponse.status, code);
  }
  return json;
}

export async function connexionLocale(courriel: string, motDePasse: string): Promise<void> {
  await poster('/api/auth/sign-in/email', { email: courriel, password: motDePasse });
}

/** Renvoie l'adresse Microsoft vers laquelle rediriger le navigateur. */
export async function connexionMicrosoft(retour: string): Promise<string> {
  const json = await poster('/api/auth/sign-in/social', {
    provider: 'microsoft',
    callbackURL: retour,
    errorCallbackURL: '/connexion',
  });
  if (typeof json.url !== 'string') throw new ErreurApi(500, 'reponse_invalide');
  return json.url;
}

export async function deconnexion(): Promise<void> {
  await poster('/api/auth/sign-out', {});
}
